export default "__VITE_ASSET__Dl16I6xf__"